export default __webpack_public_path__ + "static/media/mars50.9cf23937.gif";